import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MessageSquarePlus, X } from 'lucide-react';
import { isAuthenticated } from '../utils/auth';
import FeedbackForm from './FeedbackForm';
import FeedbackHistory from './FeedbackHistory';
import './FeedbackWidget.css';

const FeedbackWidget: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [activeTab, setActiveTab] = useState<'submit' | 'history'>('submit');
    const location = useLocation();

    // Hide on public/unauthenticated pages
    const hiddenPaths = ['/login', '/onboarding', '/candidate/', '/consent/'];
    const shouldHide = !isAuthenticated() || hiddenPaths.some(p => location.pathname.startsWith(p));

    if (shouldHide) return null;

    return (
        <>
            {/* FAB */}
            {!isOpen && (
                <button
                    className="feedback-fab"
                    onClick={() => setIsOpen(true)}
                    aria-label="Open feedback"
                    title="Send Feedback"
                >
                    <MessageSquarePlus size={24} />
                </button>
            )}

            {/* Slide-out panel */}
            {isOpen && (
                <>
                    <button type="button" className="feedback-overlay" onClick={() => setIsOpen(false)} aria-label="Dismiss panel" />
                    <div className="feedback-panel">
                        <div className="feedback-panel-header">
                            <div className="feedback-tabs">
                                <button
                                    className={`feedback-tab ${activeTab === 'submit' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('submit')}
                                >
                                    Submit Feedback
                                </button>
                                <button
                                    className={`feedback-tab ${activeTab === 'history' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('history')}
                                >
                                    My Feedback
                                </button>
                            </div>
                            <button
                                className="feedback-close"
                                onClick={() => setIsOpen(false)}
                                aria-label="Close feedback"
                            >
                                <X size={20} />
                            </button>
                        </div>
                        <div className="feedback-panel-body">
                            {activeTab === 'submit' ? (
                                <FeedbackForm onSuccess={() => setActiveTab('history')} />
                            ) : (
                                <FeedbackHistory />
                            )}
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default FeedbackWidget;
